/* tslint:disable */
/* eslint-disable */
/**
 * client-backend
 * client-backend api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface ClientInfo
 */
export interface ClientInfo {
    /**
     * 
     * @type {string}
     * @memberof ClientInfo
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientInfo
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientInfo
     */
    'mobile'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientInfo
     */
    'telExt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientInfo
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientInfo
     */
    'patronymic'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientInfo
     */
    'surname'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientInfo
     */
    'passHash'?: string;
    /**
     * 
     * @type {number}
     * @memberof ClientInfo
     */
    'dateCreated'?: number;
    /**
     * 
     * @type {number}
     * @memberof ClientInfo
     */
    'dateUpdated'?: number;
    /**
     * 
     * @type {string}
     * @memberof ClientInfo
     */
    'gender'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientInfo
     */
    'maritalStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientInfo
     */
    'address'?: string;
    /**
     * 
     * @type {RepresentativeItem}
     * @memberof ClientInfo
     */
    'representative'?: RepresentativeItem;
    /**
     * 
     * @type {string}
     * @memberof ClientInfo
     */
    'comment'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientInfo
     */
    'allergic'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientInfo
     */
    'blood'?: string;
    /**
     * 
     * @type {number}
     * @memberof ClientInfo
     */
    'birthday'?: number;
}
/**
 * 
 * @export
 * @interface CodeInfo
 */
export interface CodeInfo {
    /**
     * 
     * @type {string}
     * @memberof CodeInfo
     */
    'smsCode': string;
}
/**
 * 
 * @export
 * @interface DocList
 */
export interface DocList {
    /**
     * 
     * @type {boolean}
     * @memberof DocList
     */
    'haveDocuments': boolean;
    /**
     * 
     * @type {Array<Document>}
     * @memberof DocList
     */
    'documentsList': Array<Document>;
}
/**
 * 
 * @export
 * @interface Document
 */
export interface Document {
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    'clientId': string;
    /**
     * 
     * @type {number}
     * @memberof Document
     */
    'date': number;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    'title': string;
    /**
     * 
     * @type {Array<FileItem>}
     * @memberof Document
     */
    'filesList': Array<FileItem>;
}
/**
 * 
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {ErrorResponseError}
     * @memberof ErrorResponse
     */
    'error': ErrorResponseError;
}
/**
 * 
 * @export
 * @interface ErrorResponseError
 */
export interface ErrorResponseError {
    /**
     * Error message
     * @type {string}
     * @memberof ErrorResponseError
     */
    'message': string;
    /**
     * Error code (optional)
     * @type {number}
     * @memberof ErrorResponseError
     */
    'code'?: number;
}
/**
 * 
 * @export
 * @interface FileItem
 */
export interface FileItem {
    /**
     * src file id in DB
     * @type {string}
     * @memberof FileItem
     */
    'id': string;
    /**
     * processed file id in DB
     * @type {string}
     * @memberof FileItem
     */
    'procId': string;
    /**
     * 
     * @type {number}
     * @memberof FileItem
     */
    'date': number;
    /**
     * 
     * @type {string}
     * @memberof FileItem
     */
    'name': string;
    /**
     * file type id from ftypes table
     * @type {string}
     * @memberof FileItem
     */
    'typeId': string;
    /**
     * 
     * @type {string}
     * @memberof FileItem
     */
    'typeDesc': string;
    /**
     * 
     * @type {string}
     * @memberof FileItem
     */
    'result': string;
    /**
     * 
     * @type {string}
     * @memberof FileItem
     */
    'legend': string;
    /**
     * 
     * @type {boolean}
     * @memberof FileItem
     */
    'processable': boolean;
    /**
     * src file download url
     * @type {string}
     * @memberof FileItem
     */
    'srcDwnUrl': string;
    /**
     * processed file download url
     * @type {string}
     * @memberof FileItem
     */
    'procDwnUrl': string;
}
/**
 * 
 * @export
 * @interface Ftype
 */
export interface Ftype {
    /**
     * 
     * @type {string}
     * @memberof Ftype
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Ftype
     */
    'typeName': string;
    /**
     * Files extensions masks for type
     * @type {string}
     * @memberof Ftype
     */
    'typeExts'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Ftype
     */
    'processable': boolean;
}
/**
 * 
 * @export
 * @interface FtypesInfo
 */
export interface FtypesInfo {
    /**
     * 
     * @type {Array<Ftype>}
     * @memberof FtypesInfo
     */
    'ftypesList': Array<Ftype>;
}
/**
 * 
 * @export
 * @interface GuestInfo
 */
export interface GuestInfo {
    /**
     * 
     * @type {string}
     * @memberof GuestInfo
     */
    'emailOrMobile': string;
    /**
     * Unique device identifier
     * @type {string}
     * @memberof GuestInfo
     */
    'devId': string;
}
/**
 * 
 * @export
 * @interface GuestLoginRes
 */
export interface GuestLoginRes {
    /**
     * 
     * @type {string}
     * @memberof GuestLoginRes
     */
    'loginToken': string;
    /**
     * You can update via, seconds
     * @type {number}
     * @memberof GuestLoginRes
     */
    'updateVia': number;
}
/**
 * 
 * @export
 * @interface LangInfo
 */
export interface LangInfo {
    /**
     * 
     * @type {string}
     * @memberof LangInfo
     */
    'IETF': string;
    /**
     * 
     * @type {number}
     * @memberof LangInfo
     */
    'LCID': number;
}
/**
 * 
 * @export
 * @interface Language
 */
export interface Language {
    /**
     * 
     * @type {string}
     * @memberof Language
     */
    'IETF'?: string;
    /**
     * 
     * @type {number}
     * @memberof Language
     */
    'LCID'?: number;
}
/**
 * 
 * @export
 * @interface LogoutInfo
 */
export interface LogoutInfo {
    /**
     * 
     * @type {boolean}
     * @memberof LogoutInfo
     */
    'logout': boolean;
}
/**
 * 
 * @export
 * @interface RefreshInfo
 */
export interface RefreshInfo {
    /**
     * 
     * @type {Tokens}
     * @memberof RefreshInfo
     */
    'tokens': Tokens;
}
/**
 * 
 * @export
 * @interface RepresentativeItem
 */
export interface RepresentativeItem {
    /**
     * using if representative exist in DB
     * @type {string}
     * @memberof RepresentativeItem
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepresentativeItem
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepresentativeItem
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepresentativeItem
     */
    'mobile'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepresentativeItem
     */
    'relative'?: string;
}
/**
 * 
 * @export
 * @interface SingleClient
 */
export interface SingleClient {
    /**
     * 
     * @type {ClientInfo}
     * @memberof SingleClient
     */
    'clientInfo': ClientInfo;
}
/**
 * 
 * @export
 * @interface Tokens
 */
export interface Tokens {
    /**
     * 
     * @type {string}
     * @memberof Tokens
     */
    'accessToken': string;
    /**
     * 
     * @type {string}
     * @memberof Tokens
     */
    'refreshToken': string;
}
/**
 * 
 * @export
 * @interface UpdateLangRes
 */
export interface UpdateLangRes {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateLangRes
     */
    'updated': boolean;
}
/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'devId'?: string;
}
/**
 * 
 * @export
 * @interface UserRes
 */
export interface UserRes {
    /**
     * 
     * @type {UserResClient}
     * @memberof UserRes
     */
    'client': UserResClient;
}
/**
 * 
 * @export
 * @interface UserResClient
 */
export interface UserResClient {
    /**
     * 
     * @type {string}
     * @memberof UserResClient
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserResClient
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserResClient
     */
    'accessToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserResClient
     */
    'refreshToken'?: string;
    /**
     * 
     * @type {Language}
     * @memberof UserResClient
     */
    'language'?: Language;
}

/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get client info by id
         * @param {string} xAccessToken Access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cpaClientGet: async (xAccessToken: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xAccessToken' is not null or undefined
            assertParamExists('cpaClientGet', 'xAccessToken', xAccessToken)
            const localVarPath = `/cpa/client`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xAccessToken !== undefined && xAccessToken !== null) {
                localVarHeaderParameter['X-Access-Token'] = String(xAccessToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get documents for client id
         * @param {string} xAccessToken Access token
         * @param {string} [clientId] request by client uuid, not needed(doc_id)
         * @param {number} [dateFirst] first date, seconds since Jan 01 1970
         * @param {number} [dateLast] last date, seconds since Jan 01 1970
         * @param {string} [title] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cpaDocumentsGet: async (xAccessToken: string, clientId?: string, dateFirst?: number, dateLast?: number, title?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xAccessToken' is not null or undefined
            assertParamExists('cpaDocumentsGet', 'xAccessToken', xAccessToken)
            const localVarPath = `/cpa/documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (clientId !== undefined) {
                localVarQueryParameter['client_id'] = clientId;
            }

            if (dateFirst !== undefined) {
                localVarQueryParameter['date_first'] = dateFirst;
            }

            if (dateLast !== undefined) {
                localVarQueryParameter['date_last'] = dateLast;
            }

            if (title !== undefined) {
                localVarQueryParameter['title'] = title;
            }

            if (xAccessToken !== undefined && xAccessToken !== null) {
                localVarHeaderParameter['X-Access-Token'] = String(xAccessToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get list supported files types for AI probe
         * @param {string} xAccessToken Access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cpaFtypesGet: async (xAccessToken: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xAccessToken' is not null or undefined
            assertParamExists('cpaFtypesGet', 'xAccessToken', xAccessToken)
            const localVarPath = `/cpa/ftypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xAccessToken !== undefined && xAccessToken !== null) {
                localVarHeaderParameter['X-Access-Token'] = String(xAccessToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User login
         * @param {string} acceptLanguage IETF language code
         * @param {User} user User login info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cpaLoginPost: async (acceptLanguage: string, user: User, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'acceptLanguage' is not null or undefined
            assertParamExists('cpaLoginPost', 'acceptLanguage', acceptLanguage)
            // verify required parameter 'user' is not null or undefined
            assertParamExists('cpaLoginPost', 'user', user)
            const localVarPath = `/cpa/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(user, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Put login code
         * @param {string} xLoginToken Login token
         * @param {CodeInfo} codeInfo Guest login info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cpaLoginSmsCodePut: async (xLoginToken: string, codeInfo: CodeInfo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xLoginToken' is not null or undefined
            assertParamExists('cpaLoginSmsCodePut', 'xLoginToken', xLoginToken)
            // verify required parameter 'codeInfo' is not null or undefined
            assertParamExists('cpaLoginSmsCodePut', 'codeInfo', codeInfo)
            const localVarPath = `/cpa/login/sms/code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xLoginToken !== undefined && xLoginToken !== null) {
                localVarHeaderParameter['X-Login-Token'] = String(xLoginToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(codeInfo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Login by code
         * @param {string} acceptLanguage IETF language code
         * @param {GuestInfo} guestInfo Guest login info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cpaLoginSmsPost: async (acceptLanguage: string, guestInfo: GuestInfo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'acceptLanguage' is not null or undefined
            assertParamExists('cpaLoginSmsPost', 'acceptLanguage', acceptLanguage)
            // verify required parameter 'guestInfo' is not null or undefined
            assertParamExists('cpaLoginSmsPost', 'guestInfo', guestInfo)
            const localVarPath = `/cpa/login/sms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(guestInfo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User logout
         * @param {string} xAccessToken Access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cpaLogoutDelete: async (xAccessToken: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xAccessToken' is not null or undefined
            assertParamExists('cpaLogoutDelete', 'xAccessToken', xAccessToken)
            const localVarPath = `/cpa/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xAccessToken !== undefined && xAccessToken !== null) {
                localVarHeaderParameter['X-Access-Token'] = String(xAccessToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Refresh tokens
         * @param {string} xRefreshToken Refresh token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cpaRefreshGet: async (xRefreshToken: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xRefreshToken' is not null or undefined
            assertParamExists('cpaRefreshGet', 'xRefreshToken', xRefreshToken)
            const localVarPath = `/cpa/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xRefreshToken !== undefined && xRefreshToken !== null) {
                localVarHeaderParameter['X-Refresh-Token'] = String(xRefreshToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update language in backend
         * @param {string} xAccessToken Access token
         * @param {LangInfo} langInfo User login info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cpaUpdateLanguagePatch: async (xAccessToken: string, langInfo: LangInfo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xAccessToken' is not null or undefined
            assertParamExists('cpaUpdateLanguagePatch', 'xAccessToken', xAccessToken)
            // verify required parameter 'langInfo' is not null or undefined
            assertParamExists('cpaUpdateLanguagePatch', 'langInfo', langInfo)
            const localVarPath = `/cpa/update/language`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xAccessToken !== undefined && xAccessToken !== null) {
                localVarHeaderParameter['X-Access-Token'] = String(xAccessToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(langInfo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * Get client info by id
         * @param {string} xAccessToken Access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cpaClientGet(xAccessToken: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SingleClient>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cpaClientGet(xAccessToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get documents for client id
         * @param {string} xAccessToken Access token
         * @param {string} [clientId] request by client uuid, not needed(doc_id)
         * @param {number} [dateFirst] first date, seconds since Jan 01 1970
         * @param {number} [dateLast] last date, seconds since Jan 01 1970
         * @param {string} [title] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cpaDocumentsGet(xAccessToken: string, clientId?: string, dateFirst?: number, dateLast?: number, title?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cpaDocumentsGet(xAccessToken, clientId, dateFirst, dateLast, title, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get list supported files types for AI probe
         * @param {string} xAccessToken Access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cpaFtypesGet(xAccessToken: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FtypesInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cpaFtypesGet(xAccessToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * User login
         * @param {string} acceptLanguage IETF language code
         * @param {User} user User login info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cpaLoginPost(acceptLanguage: string, user: User, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cpaLoginPost(acceptLanguage, user, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Put login code
         * @param {string} xLoginToken Login token
         * @param {CodeInfo} codeInfo Guest login info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cpaLoginSmsCodePut(xLoginToken: string, codeInfo: CodeInfo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cpaLoginSmsCodePut(xLoginToken, codeInfo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Login by code
         * @param {string} acceptLanguage IETF language code
         * @param {GuestInfo} guestInfo Guest login info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cpaLoginSmsPost(acceptLanguage: string, guestInfo: GuestInfo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuestLoginRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cpaLoginSmsPost(acceptLanguage, guestInfo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * User logout
         * @param {string} xAccessToken Access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cpaLogoutDelete(xAccessToken: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LogoutInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cpaLogoutDelete(xAccessToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Refresh tokens
         * @param {string} xRefreshToken Refresh token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cpaRefreshGet(xRefreshToken: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RefreshInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cpaRefreshGet(xRefreshToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update language in backend
         * @param {string} xAccessToken Access token
         * @param {LangInfo} langInfo User login info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cpaUpdateLanguagePatch(xAccessToken: string, langInfo: LangInfo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateLangRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cpaUpdateLanguagePatch(xAccessToken, langInfo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * Get client info by id
         * @param {string} xAccessToken Access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cpaClientGet(xAccessToken: string, options?: any): AxiosPromise<SingleClient> {
            return localVarFp.cpaClientGet(xAccessToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Get documents for client id
         * @param {string} xAccessToken Access token
         * @param {string} [clientId] request by client uuid, not needed(doc_id)
         * @param {number} [dateFirst] first date, seconds since Jan 01 1970
         * @param {number} [dateLast] last date, seconds since Jan 01 1970
         * @param {string} [title] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cpaDocumentsGet(xAccessToken: string, clientId?: string, dateFirst?: number, dateLast?: number, title?: string, options?: any): AxiosPromise<DocList> {
            return localVarFp.cpaDocumentsGet(xAccessToken, clientId, dateFirst, dateLast, title, options).then((request) => request(axios, basePath));
        },
        /**
         * Get list supported files types for AI probe
         * @param {string} xAccessToken Access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cpaFtypesGet(xAccessToken: string, options?: any): AxiosPromise<FtypesInfo> {
            return localVarFp.cpaFtypesGet(xAccessToken, options).then((request) => request(axios, basePath));
        },
        /**
         * User login
         * @param {string} acceptLanguage IETF language code
         * @param {User} user User login info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cpaLoginPost(acceptLanguage: string, user: User, options?: any): AxiosPromise<UserRes> {
            return localVarFp.cpaLoginPost(acceptLanguage, user, options).then((request) => request(axios, basePath));
        },
        /**
         * Put login code
         * @param {string} xLoginToken Login token
         * @param {CodeInfo} codeInfo Guest login info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cpaLoginSmsCodePut(xLoginToken: string, codeInfo: CodeInfo, options?: any): AxiosPromise<UserRes> {
            return localVarFp.cpaLoginSmsCodePut(xLoginToken, codeInfo, options).then((request) => request(axios, basePath));
        },
        /**
         * Login by code
         * @param {string} acceptLanguage IETF language code
         * @param {GuestInfo} guestInfo Guest login info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cpaLoginSmsPost(acceptLanguage: string, guestInfo: GuestInfo, options?: any): AxiosPromise<GuestLoginRes> {
            return localVarFp.cpaLoginSmsPost(acceptLanguage, guestInfo, options).then((request) => request(axios, basePath));
        },
        /**
         * User logout
         * @param {string} xAccessToken Access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cpaLogoutDelete(xAccessToken: string, options?: any): AxiosPromise<LogoutInfo> {
            return localVarFp.cpaLogoutDelete(xAccessToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Refresh tokens
         * @param {string} xRefreshToken Refresh token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cpaRefreshGet(xRefreshToken: string, options?: any): AxiosPromise<RefreshInfo> {
            return localVarFp.cpaRefreshGet(xRefreshToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Update language in backend
         * @param {string} xAccessToken Access token
         * @param {LangInfo} langInfo User login info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cpaUpdateLanguagePatch(xAccessToken: string, langInfo: LangInfo, options?: any): AxiosPromise<UpdateLangRes> {
            return localVarFp.cpaUpdateLanguagePatch(xAccessToken, langInfo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for cpaClientGet operation in DefaultApi.
 * @export
 * @interface DefaultApiCpaClientGetRequest
 */
export interface DefaultApiCpaClientGetRequest {
    /**
     * Access token
     * @type {string}
     * @memberof DefaultApiCpaClientGet
     */
    readonly xAccessToken: string
}

/**
 * Request parameters for cpaDocumentsGet operation in DefaultApi.
 * @export
 * @interface DefaultApiCpaDocumentsGetRequest
 */
export interface DefaultApiCpaDocumentsGetRequest {
    /**
     * Access token
     * @type {string}
     * @memberof DefaultApiCpaDocumentsGet
     */
    readonly xAccessToken: string

    /**
     * request by client uuid, not needed(doc_id)
     * @type {string}
     * @memberof DefaultApiCpaDocumentsGet
     */
    readonly clientId?: string

    /**
     * first date, seconds since Jan 01 1970
     * @type {number}
     * @memberof DefaultApiCpaDocumentsGet
     */
    readonly dateFirst?: number

    /**
     * last date, seconds since Jan 01 1970
     * @type {number}
     * @memberof DefaultApiCpaDocumentsGet
     */
    readonly dateLast?: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiCpaDocumentsGet
     */
    readonly title?: string
}

/**
 * Request parameters for cpaFtypesGet operation in DefaultApi.
 * @export
 * @interface DefaultApiCpaFtypesGetRequest
 */
export interface DefaultApiCpaFtypesGetRequest {
    /**
     * Access token
     * @type {string}
     * @memberof DefaultApiCpaFtypesGet
     */
    readonly xAccessToken: string
}

/**
 * Request parameters for cpaLoginPost operation in DefaultApi.
 * @export
 * @interface DefaultApiCpaLoginPostRequest
 */
export interface DefaultApiCpaLoginPostRequest {
    /**
     * IETF language code
     * @type {string}
     * @memberof DefaultApiCpaLoginPost
     */
    readonly acceptLanguage: string

    /**
     * User login info
     * @type {User}
     * @memberof DefaultApiCpaLoginPost
     */
    readonly user: User
}

/**
 * Request parameters for cpaLoginSmsCodePut operation in DefaultApi.
 * @export
 * @interface DefaultApiCpaLoginSmsCodePutRequest
 */
export interface DefaultApiCpaLoginSmsCodePutRequest {
    /**
     * Login token
     * @type {string}
     * @memberof DefaultApiCpaLoginSmsCodePut
     */
    readonly xLoginToken: string

    /**
     * Guest login info
     * @type {CodeInfo}
     * @memberof DefaultApiCpaLoginSmsCodePut
     */
    readonly codeInfo: CodeInfo
}

/**
 * Request parameters for cpaLoginSmsPost operation in DefaultApi.
 * @export
 * @interface DefaultApiCpaLoginSmsPostRequest
 */
export interface DefaultApiCpaLoginSmsPostRequest {
    /**
     * IETF language code
     * @type {string}
     * @memberof DefaultApiCpaLoginSmsPost
     */
    readonly acceptLanguage: string

    /**
     * Guest login info
     * @type {GuestInfo}
     * @memberof DefaultApiCpaLoginSmsPost
     */
    readonly guestInfo: GuestInfo
}

/**
 * Request parameters for cpaLogoutDelete operation in DefaultApi.
 * @export
 * @interface DefaultApiCpaLogoutDeleteRequest
 */
export interface DefaultApiCpaLogoutDeleteRequest {
    /**
     * Access token
     * @type {string}
     * @memberof DefaultApiCpaLogoutDelete
     */
    readonly xAccessToken: string
}

/**
 * Request parameters for cpaRefreshGet operation in DefaultApi.
 * @export
 * @interface DefaultApiCpaRefreshGetRequest
 */
export interface DefaultApiCpaRefreshGetRequest {
    /**
     * Refresh token
     * @type {string}
     * @memberof DefaultApiCpaRefreshGet
     */
    readonly xRefreshToken: string
}

/**
 * Request parameters for cpaUpdateLanguagePatch operation in DefaultApi.
 * @export
 * @interface DefaultApiCpaUpdateLanguagePatchRequest
 */
export interface DefaultApiCpaUpdateLanguagePatchRequest {
    /**
     * Access token
     * @type {string}
     * @memberof DefaultApiCpaUpdateLanguagePatch
     */
    readonly xAccessToken: string

    /**
     * User login info
     * @type {LangInfo}
     * @memberof DefaultApiCpaUpdateLanguagePatch
     */
    readonly langInfo: LangInfo
}

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * Get client info by id
     * @param {DefaultApiCpaClientGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public cpaClientGet(requestParameters: DefaultApiCpaClientGetRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).cpaClientGet(requestParameters.xAccessToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get documents for client id
     * @param {DefaultApiCpaDocumentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public cpaDocumentsGet(requestParameters: DefaultApiCpaDocumentsGetRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).cpaDocumentsGet(requestParameters.xAccessToken, requestParameters.clientId, requestParameters.dateFirst, requestParameters.dateLast, requestParameters.title, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get list supported files types for AI probe
     * @param {DefaultApiCpaFtypesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public cpaFtypesGet(requestParameters: DefaultApiCpaFtypesGetRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).cpaFtypesGet(requestParameters.xAccessToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * User login
     * @param {DefaultApiCpaLoginPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public cpaLoginPost(requestParameters: DefaultApiCpaLoginPostRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).cpaLoginPost(requestParameters.acceptLanguage, requestParameters.user, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Put login code
     * @param {DefaultApiCpaLoginSmsCodePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public cpaLoginSmsCodePut(requestParameters: DefaultApiCpaLoginSmsCodePutRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).cpaLoginSmsCodePut(requestParameters.xLoginToken, requestParameters.codeInfo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Login by code
     * @param {DefaultApiCpaLoginSmsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public cpaLoginSmsPost(requestParameters: DefaultApiCpaLoginSmsPostRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).cpaLoginSmsPost(requestParameters.acceptLanguage, requestParameters.guestInfo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * User logout
     * @param {DefaultApiCpaLogoutDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public cpaLogoutDelete(requestParameters: DefaultApiCpaLogoutDeleteRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).cpaLogoutDelete(requestParameters.xAccessToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Refresh tokens
     * @param {DefaultApiCpaRefreshGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public cpaRefreshGet(requestParameters: DefaultApiCpaRefreshGetRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).cpaRefreshGet(requestParameters.xRefreshToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update language in backend
     * @param {DefaultApiCpaUpdateLanguagePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public cpaUpdateLanguagePatch(requestParameters: DefaultApiCpaUpdateLanguagePatchRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).cpaUpdateLanguagePatch(requestParameters.xAccessToken, requestParameters.langInfo, options).then((request) => request(this.axios, this.basePath));
    }
}


